import React from "react"
import DotsAndLines from "../components/DotsAndLines.js"
import Check from "../images/green_check.svg"

const SeeIfMatch = () => (
  <>
    <div className="md:flex max-w-page mt-12 lg:mt-24 lg:py-24 text-black">
      <div className="flex-1">
        <div className="w-3/4 mx-auto pt-10 text-center md:text-left">
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-extrabold">
            See if you are a <span className='text-primary-txt'>match.</span>
          </h2>
          <p className="text-lg md:text-xl my-4">
            We are looking for financially responsible individuals seeking fair access to credit.
          </p>
        </div>
      </div>

      <div className="pt-32 pb-16 lg:py-0 text-black" style={{flex: '1.3 1.3 0%'}}>
        <DotsAndLines>
          <div className="bg-white shadow-faint w-10/12 -mt-20sm:w-3/4 mx-auto px-5 sm:px-4 lg:px-12 py-8 flex flex-col rounded-lg">
            <h3 className="text-2xl lg:text-3xl font-extrabold my-3">Are you looking for...</h3>
            <div className="flex my-3">
              <img src={Check} className="px-3"/>
              <p>A credit card that doesn't require a credit history</p>
            </div>
            <div className="flex my-3">
              <img src={Check} className="px-3"/>
              <p>Expedited and automated payment options to improve your credit quickly</p>
            </div>
            <div className="flex my-3">
              <img src={Check} className="px-3"/>
              <p>Control of your finances</p>
            </div>
            <div className="flex my-3">
              <img src={Check} className="px-3"/>
              <p>A product focused on being inclusive</p>
            </div>
          </div>
        </DotsAndLines>
      </div>
    </div>

    <div className="w-full bg-primary-btn text-primary-dark text-center text-xl lg:text-2xl mt-24 p-12">
      Looks like you've come to the right place :)
    </div>
  </>
);

export default SeeIfMatch;
